import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { listAllCheckins } from '../../api/calls';
import '../CheckInModal/modalOverwrite.css';

const AllCheckInsModal = ({ show, onHide, members }) => {
    const [checkins, setCheckins] = useState([]);
    const [sortField, setSortField] = useState('checkin');
    const [sortDir, setSortDir] = useState('desc');
    const [todayOnly, setTodayOnly] = useState(false);

    useEffect(() => {
        if (show) {
            listAllCheckins().then(data => setCheckins(data || []));
        }
    }, [show]);

    const handleSort = (field) => {
        if (field === sortField) {
            setSortDir(d => d === 'asc' ? 'desc' : 'asc');
        } else {
            setSortField(field);
            setSortDir(field === 'checkin' ? 'desc' : 'asc');
        }
    };

    const indicator = (field) => field === sortField ? (sortDir === 'asc' ? ' ▲' : ' ▼') : '';

    const memberMap = members
        ? members.reduce((acc, m) => { acc[m.PK] = m; return acc; }, {})
        : {};

    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);

    const filtered = todayOnly
        ? checkins.filter(c => c.checkin >= todayStart.getTime())
        : checkins;

    const sorted = [...filtered].sort((a, b) => {
        let aVal, bVal;
        if (sortField === 'member') {
            const aM = memberMap[a.member];
            const bM = memberMap[b.member];
            aVal = aM ? `${aM.lastName} ${aM.firstName}` : (a.member ?? '');
            bVal = bM ? `${bM.lastName} ${bM.firstName}` : (b.member ?? '');
        } else {
            aVal = a[sortField] ?? 0;
            bVal = b[sortField] ?? 0;
        }
        if (typeof aVal === 'number' && typeof bVal === 'number') {
            return sortDir === 'asc' ? aVal - bVal : bVal - aVal;
        }
        const aStr = String(aVal).toLowerCase();
        const bStr = String(bVal).toLowerCase();
        if (aStr < bStr) return sortDir === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortDir === 'asc' ? 1 : -1;
        return 0;
    });

    const thStyle = {
        cursor: 'pointer',
        userSelect: 'none',
        backgroundColor: '#4a6fa5',
        color: '#fff',
        borderColor: '#3a5a8f',
    };

    return (
        <Modal show={show} onHide={onHide} dialogClassName="modal-90w" centered>
            <Modal.Header closeButton>
                <Modal.Title>Check-In Log</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ backgroundColor: '#f5f7fa' }}>
                <div className="mb-2">
                    <label style={{ cursor: 'pointer', userSelect: 'none' }}>
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={todayOnly}
                            onChange={e => setTodayOnly(e.target.checked)}
                        />
                        Today only
                    </label>
                </div>
                <Table striped bordered size="sm">
                    <thead>
                        <tr>
                            <th style={thStyle} onClick={() => handleSort('checkin')}>Date{indicator('checkin')}</th>
                            <th style={thStyle} onClick={() => handleSort('member')}>Member{indicator('member')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sorted.map((c) => {
                            const m = memberMap[c.member];
                            const rowStyle = todayOnly ? { backgroundColor: '#eaf7ea' } : {};
                            return (
                                <tr key={`${c.member}-${c.checkin}`} style={rowStyle}>
                                    <td>{new Date(c.checkin).toLocaleString()}</td>
                                    <td>{m ? `${m.lastName}, ${m.firstName}` : (c.member ?? '—')}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    );
};

export default AllCheckInsModal;
